export default __webpack_public_path__ + "static/media/Sonox Logo _ Premium.60a17b94.png";